import { Outlet } from "@tanstack/react-router"
import { ButtonLink } from "design-system/atoms/Button"
import { BadgePingText } from "design-system/molecules/BadgePingText"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { Pencil } from "lucide-react"
import { useKlaviyoIntegrationQuery } from "modules/settings/hooks/klaviyo/useKlaviyoIntegrationQuery"
import { useTranslation } from "react-i18next"

export const KlaviyoIntegration = () => {
  const { t } = useTranslation()
  const { data: integration } = useKlaviyoIntegrationQuery()
  const hasConfiguration = integration?.apiKey

  return (
    <>
      <Card>
        <CardHeader className="flex flex-row gap-4 p-4">
          <div className="grow flex flex-col gap-1">
            <CardTitle>{t("settings.integrations.klaviyo.integrationCard.title")}</CardTitle>
            <CardDescription>
              {hasConfiguration
                ? t("settings.integrations.klaviyo.integrationCard.descriptionDone")
                : t("settings.integrations.klaviyo.integrationCard.descriptionPending")}
            </CardDescription>
          </div>
          <div className="flex items-center">
            {hasConfiguration ? (
              <div className="flex gap-2">
                <BadgePingText
                  color={"success"}
                  text={t("settings.integrations.klaviyo.integrationCard.connected")}
                />
                <ButtonLink
                  variant={"ghost"}
                  size="icon"
                  to="/settings/integrations/klaviyo/connect"
                >
                  <Pencil />
                </ButtonLink>
              </div>
            ) : (
              <ButtonLink to={"/settings/integrations/klaviyo/connect"}>
                {t("settings.integrations.klaviyo.integrationCard.configButton")}
              </ButtonLink>
            )}
          </div>
        </CardHeader>
      </Card>

      <Outlet />
    </>
  )
}
